// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Qi8R","title":"styles_title__2Einn"};